module.exports = __webpack_public_path__ + "static/media/ynbg.020fa862.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/common/image/ynbg.jpg
// module id = 670
// module chunks = 2